export default "__VITE_ASSET__BYhII7q6__"